<template>
  <div class="card" ref="formContainer">
    <div class="card-body">
      <div class="row">
        <div class="col-3 mb-4">
          <datepicker
            v-model="startdate"
            placeholder="Choose Date"
            class="form-control floating datetimepicker"
            :editable="true"
            :clearable="false"
            :input-format="dateFormat"
          />
        </div>
        <div class="col-3 mb-4">
          <div class="d-flex align-items-center ms-3">
            <b-button variant="link" class="p-2" @click="goToPreviousDay">
              <i class="fas fa-chevron-left text-purple"></i>
            </b-button>

            <b-button variant="link" class="p-2 ms-2" @click="goToNextDay">
              <i class="fas fa-chevron-right text-purple"></i>
            </b-button>
          </div>
        </div>
      </div>

      <Form @submit="onSearch">
        <div class="row filter-row">
          <div class="col-sm-6 col-md-3" v-if="!userRole">
            <div class="input-block mb-3 form-focus focused">
              <vue-select
                :options="employee_list"
                id="projectreportname"
                v-model="searchform.s_employee_id"
                placeholder="-"
              />

              <label class="focus-label">Employee Name</label>
            </div>
          </div>

          <div class="col-sm-6 col-md-2" v-if="!userRole">
            <div class="input-block mb-3 form-focus focused">
              <vue-select
                :options="designation_list"
                id="designation_id"
                v-model="searchform.designation_id"
                placeholder="-"
              />

              <label class="focus-label">Select Position</label>
            </div>
          </div>

          <div class="col-sm-6 col-md-3">
            <div class="input-block mb-3 form-focus select-focus">
              <vue-select
                :options="Reasons"
                id="year"
                placeholder="-"
                v-model="searchform.reason"
              />
              <label class="focus-label">Select Reason</label>
            </div>
          </div>
          <!--<div class="col-sm-6 col-md-2">
              <div class="input-block mb-3 form-focus select-focus">
                <vue-select
                  :options="Month"
                  id="month"
                  placeholder="-"
                  v-model="searchform.month"
                />
                <label class="focus-label">Select Month</label>
              </div>
            </div> -->
          <div class="col-sm-6 col-md-2">
            <div class="d-grid">
              <button class="btn btn-success w-100 mb-3 submit-btn">
                Search
              </button>
            </div>
          </div>

          <div class="col-sm-6 col-md-2">
            <div class="d-grid">
              <a
                href="javascript:void(0)"
                class="btn btn-danger w-100 submit-btn"
                @click="clearForm"
                >Clear</a
              >
            </div>
          </div>
        </div>
      </Form>

      <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <div class="showentries">
          <label
            >Show
            <select v-model="pagination.pageSize" @change="updatePerPage">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            entries</label
          >
        </div>
        <div v-if="hasExportPermission" class="btn-group">
          <a
            type="button"
            class="btn btn-primary dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-download me-1"></i> Download
          </a>
          <ul class="dropdown-menu">
            <li>
              <a
                class="dropdown-item"
                href="javascript:;"
                @click="downloadDailyReview('export-daily-review', 'excel')"
              >
                <i class="fa-solid fa-file-excel me-2"></i> Excel
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                href="javascript:;"
                @click="downloadDailyReview('export-daily-review-pdf', 'pdf')"
              >
                <i class="fa-solid fa-file-pdf me-2"></i> PDF
              </a>
            </li>
          </ul>
        </div>
      </div>

      <a-table
        class="stripped table-hover"
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'team_member'">
            <a
              href="javascript:;"
              data-bs-toggle="modal"
              data-bs-target="#edit_timesheet"
              @click="editTimesheet(record)"
            >
              <div class="d-flex align-items-center">
                <a-avatar class="me-2" style="background-color: #ccc">
                  <img
                    v-if="record?.avatar && record?.avatar != null"
                    :src="getEmployeeAvatar(record?.avatar)"
                    alt="User Image"
                    @error="handleImageError(record)"
                  />
                  <img
                    v-else
                    :src="require(`@/assets/img/profiles/${defaultAvatar}`)"
                    alt="User Image"
                  />
                </a-avatar>
                <div>
                  <div>
                    <strong
                      >{{ record.first_name }} {{ record.last_name }}</strong
                    >
                  </div>

                  <small
                    class="text-muted"
                    v-if="record.dailyreport.designationdetails"
                  >
                    {{ record.dailyreport.designationdetails.name }}
                  </small>
                  <small class="text-muted" v-else>
                    {{
                      record?.designation && record?.designation.name
                        ? record?.designation.name
                        : "-"
                    }}
                  </small>
                </div>
              </div>
            </a>
          </template>
          <template v-if="column.key === 'worked'">
            <a
              href="javascript:;"
              data-bs-toggle="modal"
              data-bs-target="#edit_timesheet"
              @click="editTimesheet(record)"
            >
              <div>
                <div v-if="record.dailyreport?.total_hours == 0">
                  {{
                    record.dailyreport?.firstpunch
                      ? formatToAmPm(record.dailyreport.firstpunch)
                      : "--"
                  }}
                  :
                  {{
                    record.dailyreport?.lastpunch
                      ? formatToAmPm(record.dailyreport.lastpunch)
                      : "--"
                  }}
                  <i
                    v-if="record.dailyreport?.is_unscheduled"
                    class="fa-solid fa-warning text-warning"
                  ></i>
                </div>
                <div v-else>
                  {{ formatToAmPm(record.dailyreport?.firstpunch) }} -
                  {{ formatToAmPm(record.dailyreport?.lastpunch) }}
                  <i
                    v-if="record.dailyreport?.is_unscheduled"
                    class="fa-solid fa-warning text-warning"
                  ></i>
                  <br />
                  {{
                    convertHoursToTimeFormat(record.dailyreport?.total_hours) ||
                    "--:--"
                  }}
                </div>
                <div v-if="record.assigned_shift.length">
                  <small
                    class="text-muted"
                    v-for="singleshift in record.assigned_shift"
                  >
                    Scheduled:
                    {{
                      formatTimeRange(
                        singleshift.shift.start_time,
                        singleshift.shift.end_time
                      )
                    }}
                    <br />
                  </small>
                </div>
                <div v-else>
                  <small class="text-muted"> Scheduled: - </small>
                </div>
              </div>
            </a>
          </template>
          <template v-if="column.key === 'total_paid_breaks'">
            <a
              href="javascript:;"
              data-bs-toggle="modal"
              data-bs-target="#edit_timesheet"
              @click="editTimesheet(record)"
            >
              {{ record.dailyreport?.list_breaks.total_break_minutes || "0" }}
              min
            </a>
          </template>
          <template v-if="column.key === 'total_unpaid_breaks'">
            <a
              href="javascript:;"
              data-bs-toggle="modal"
              data-bs-target="#edit_timesheet"
              @click="editTimesheet(record)"
            >
              {{
                record.dailyreport?.both_list_breaks.total_unpaid_minutes || "0"
              }}
              min
            </a>
          </template>
          <template v-if="column.key === 'issues'">
            <a
              href="javascript:;"
              data-bs-toggle="modal"
              data-bs-target="#edit_timesheet"
              @click="editTimesheet(record)"
            >
              <div
                class="text-danger"
                v-if="
                  record.dailyreport &&
                  record.dailyreport?.total_hours <= 0 &&
                  record.dailyreport?.reason != ''
                "
              >
                <a-icon type="exclamation-circle" class="me-1" />
                {{ record.dailyreport?.reason }}
              </div>
              <div
                class="text-danger"
                v-if="
                  record.dailyreport &&
                  record.dailyreport?.total_hours <= 0 &&
                  record.dailyreport?.reason == ''
                "
              >
                <a-icon type="exclamation-circle" class="me-1" />
                No show
              </div>
            </a>
          </template>
          <template v-if="column.key === 'actions'">
            <a-dropdown
              trigger="click"
              v-if="
                record.dailyreport?.total_hours <= 0 &&
                record.dailyreport?.reason == ''
              "
            >
              <a-button type="link"
                >Resolve issues <a-icon type="down"
              /></a-button>
              <template #overlay>
                <a-menu>
                  <a-sub-menu title="Add reason for no show">
                    <a-menu-item
                      @click="
                        handleAction('reason', record, 'No Longer Required')
                      "
                      >No Longer Required</a-menu-item
                    >
                    <a-menu-item
                      @click="
                        handleAction('reason', record, 'Personal Emergency')
                      "
                      >Personal Emergency</a-menu-item
                    >
                    <a-menu-item @click="handleAction('reason', record, 'Sick')"
                      >Sick</a-menu-item
                    >
                    <a-menu-item
                      @click="
                        handleAction('reason', record, 'Unexplained Absence')
                      "
                      >Unexplained Absence</a-menu-item
                    >
                    <a-menu-item
                      @click="handleAction('reason', record, 'Other')"
                      >Other</a-menu-item
                    >
                  </a-sub-menu>
                  <a-menu-item @click="handleAction('scheduled', record)">
                    <a-icon type="plus" /> Add times as scheduled
                  </a-menu-item>
                  <a-menu-item @click="handleAction('newTimes', record)">
                    <a-icon type="plus" /> Add new times
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </template>
      </a-table>
    </div>
  </div>

  <div id="edit_timesheet" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Timesheet Details</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="imptimessheetclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onUpdate">
            <!-- Date & Employee Info -->

            <i
              class="fa fa-trash"
              style="cursor: pointer; color: red; float: right"
              @click="
                deleteTimesheet(
                  Number(selectedtimesheet.dailyreport?.attendanceid) || 0
                )
              "
            ></i>
            <p class="text-muted mb-1">{{ formatDate(startdate) }}</p>
            <h5>
              <strong
                >{{ selectedtimesheet.first_name }}
                {{ selectedtimesheet.last_name }}</strong
              >
            </h5>

            <!-- Role & Location -->

            <b-form-group
              class="mb-3 d-flex align-items-center"
              v-if="selectedtimesheet.dailyreport?.designationdetails"
            >
              <b-form-select
                class="me-2"
                :options="[
                  selectedtimesheet.dailyreport?.designationdetails.name || '',
                ]"
                v-model="selectedDesignation"
              >
              </b-form-select>
              <span class="text-muted"
                >at {{ selectedtimesheet.office?.office_name || "" }}</span
              >
            </b-form-group>
            <b-form-group class="mb-3 d-flex align-items-center" v-else>
              <b-form-select
                class="me-2"
                :options="[selectedtimesheet.designation?.name || '']"
                v-model="selectedDesignation"
              >
              </b-form-select>
              <span class="text-muted"
                >at {{ selectedtimesheet.office?.office_name || "" }}</span
              >
            </b-form-group>
            <!-- Worked Time -->
            <b-card class="mb-3">
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <h6 class="mb-0">
                  <b-icon icon="clock-fill" class="me-2"></b-icon>

                  Worked
                  <small class="text-muted"
                    >({{
                      convertHoursToTimeFormat(
                        selectedtimesheet.dailyreport?.total_hours || "0"
                      )
                    }})</small
                  >
                </h6>
              </div>

              <b-row class="mb-2">
                <b-col cols="6">
                  <label
                    >Clocked in ({{
                      selectedtimesheet.dailyreport?.firstpunch
                    }})</label
                  >
                  <div class="input-group time">
                    <a-date-picker
                      v-model:value="form.punch_in_time"
                      format="YYYY-MM-DD hh:mm A"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      show-time
                      use12-hours
                      placeholder="Select date and time"
                      class="form-control datetimepicker"
                    />

                    <!--
							<a-time-picker
							  v-model:value="form.punch_in_time"
							  format="hh:mm A"          
							  value-format="HH:mm"      
							  use12-hours
							  class="form-control timepicker"
							  placeholder="hh:mm AM/PM"
							/>
							-->
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                </b-col>
                <b-col cols="6">
                  <label
                    >Clocked out ({{
                      selectedtimesheet.dailyreport?.lastpunch
                    }})</label
                  >
                  <div class="input-group time">
                    <a-date-picker
                      v-model:value="form.punch_out_time"
                      format="YYYY-MM-DD hh:mm A"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      show-time
                      use12-hours
                      placeholder="Select date and time"
                      class="form-control datetimepicker"
                    />

                    <!--
							<a-time-picker
							  v-model:value="form.punch_out_time"
							  format="hh:mm A"          
							  value-format="HH:mm"      
							  use12-hours
							  class="form-control timepicker"
							  placeholder="hh:mm AM/PM"
							/>
							
							-->

                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                </b-col>
              </b-row>

              <b-p class="mb-0 text-muted">
                <div
                  v-if="
                    selectedtimesheet.assigned_shift &&
                    selectedtimesheet.assigned_shift.length > 0
                  "
                >
                  <small
                    class="text-muted"
                    v-for="singleshift in selectedtimesheet.assigned_shift"
                  >
                    Scheduled:
                    {{
                      formatTimeRange(
                        singleshift.shift.start_time,
                        singleshift.shift.end_time
                      )
                    }}
                  </small>
                </div>
                <div v-else>Scheduled: -</div>
              </b-p>
            </b-card>

            <!-- Breaks Section -->
            <b-card>
              <h6 class="mb-3">
                <b-icon icon="cup-hot-fill" class="me-2"></b-icon>
                Breaks ({{
                  selectedtimesheet.dailyreport?.list_breaks?.breaks?.length ||
                  "0"
                }})
              </h6>

              <!-- Paid Break -->
              <label class="fw-bold">Total paid break time</label>
              <div
                v-if="
                  selectedtimesheet.dailyreport?.list_breaks?.breaks?.length
                "
              >
                <b-row
                  class="align-items-center mb-2"
                  v-for="(entry, index) in selectedtimesheet.dailyreport
                    .list_breaks.breaks"
                  :key="index"
                >
                  <b-col cols="5">
                    <div class="input-group time">
                      <a-date-picker
                        v-model:value="entry.punch_out_time_str"
                        format="YYYY-MM-DD hh:mm A"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        show-time
                        use12-hours
                        placeholder="Select date and time"
                        class="form-control datetimepicker"
                      />
                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                  </b-col>
                  <b-col cols="5">
                    <div class="input-group time">
                      <a-date-picker
                        v-model:value="entry.punch_in_time_str"
                        format="YYYY-MM-DD hh:mm A"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        show-time
                        use12-hours
                        placeholder="Select date and time"
                        class="form-control datetimepicker"
                      />
                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                  </b-col>
                  <b-col cols="2">
                    <i
                      class="fa fa-trash"
                      style="cursor: pointer; color: red"
                      @click="removeBreak(index)"
                    ></i>
                  </b-col>
                </b-row>
              </div>
              <b-button
                variant="link"
                class="p-0 text-primary"
                @click="addBreak"
              >
                <b-icon icon="plus-circle" class="me-1" /> Add a break
              </b-button>
              <br />

              <h6 class="mb-3 mt-3">
                <b-icon icon="cup-hot-fill" class="me-2"></b-icon>
                Unpaid Breaks ({{
                  selectedtimesheet.dailyreport?.both_list_breaks?.unpaid_breaks
                    ?.length || "0"
                }})
              </h6>

              <label class="fw-bold">Total Unpaid break time</label>
              <div
                v-if="
                  selectedtimesheet.dailyreport?.both_list_breaks?.unpaid_breaks
                    ?.length
                "
              >
                <b-row
                  class="align-items-center mb-2"
                  v-for="(entry, index) in selectedtimesheet.dailyreport
                    .both_list_breaks.unpaid_breaks"
                  :key="index"
                >
                  <b-col cols="5">
                    <div class="input-group time">
                      <a-date-picker
                        v-model:value="entry.punch_out_time_str"
                        format="YYYY-MM-DD hh:mm A"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        show-time
                        use12-hours
                        placeholder="Select date and time"
                        class="form-control datetimepicker"
                      />
                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                  </b-col>
                  <b-col cols="5">
                    <div class="input-group time">
                      <a-date-picker
                        v-model:value="entry.punch_in_time_str"
                        format="YYYY-MM-DD hh:mm A"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        show-time
                        use12-hours
                        placeholder="Select date and time"
                        class="form-control datetimepicker"
                      />
                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                  </b-col>
                  <b-col cols="2">
                    <i
                      class="fa fa-trash"
                      style="cursor: pointer; color: red"
                      @click="removeBreakUnpaid(index)"
                    ></i>
                  </b-col>
                </b-row>
              </div>

              <b-button
                variant="link"
                class="p-0 text-primary"
                @click="addBreakUnpaid"
              >
                <b-icon icon="plus-circle" class="me-1" /> Add a break
              </b-button>
            </b-card>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Save</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>

  <div id="add_timesheet" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Time Card</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="impaddtimessheetclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form
            @submit="onSubmit"
            :validation-schema="schema"
            v-slot="{ errors }"
          >
            <!-- Date & Employee Info -->
            <div class="input-block mb-3">
              <datepicker
                v-model="addstartdate"
                placeholder="Choose Date"
                class="form-control floating datetimepicker"
                :editable="true"
                :clearable="false"
                :input-format="dateFormat"
              />
            </div>
            <div class="input-block mb-3">
              <Field
                name="user_id"
                as="select"
                class="form-control"
                v-model="addform.user_id"
                :class="{ 'is-invalid': errors.user_id }"
              >
                <option value="">Select Employee</option>
                <option
                  v-for="employee in employee_list2"
                  :key="employee.id"
                  :value="employee.id"
                >
                  {{ employee.first_name }} {{ employee.last_name }}
                </option>
                <div class="invalid-feedback">{{ errors.user_id }}</div>
                <div class="employee_idshow text-danger" id="user_id"></div>
              </Field>
            </div>
            <div class="input-block mb-3">
              <Field
                name="designation_id"
                as="select"
                class="form-control"
                v-model="addform.designation_id"
                :class="{ 'is-invalid': errors.designation_id }"
              >
                <option value="">Select Designation</option>
                <option
                  v-for="employee in designation_list2"
                  :key="employee.id"
                  :value="employee.id"
                >
                  {{ employee.name }}
                </option>
                <div class="invalid-feedback">{{ errors.designation_id }}</div>
                <div
                  class="designation_idshow text-danger"
                  id="designation_id"
                ></div>
              </Field>
            </div>

            <!-- Worked Time -->
            <b-card class="mb-3">
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <h6 class="mb-0">
                  <b-icon icon="clock-fill" class="me-2"></b-icon>
                  Worked
                </h6>
              </div>

              <b-row class="mb-2">
                <b-col cols="6">
                  <label>Clocked in</label>
                  <div class="input-group time">
                    <a-date-picker
                      v-model:value="addform.punch_in_time"
                      format="YYYY-MM-DD hh:mm A"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      show-time
                      use12-hours
                      placeholder="Select date and time"
                      class="form-control datetimepicker"
                    />
                    <!--
							<a-time-picker
							  v-model:value="addform.punch_in_time"
							  format="hh:mm A"          
							  value-format="HH:mm"      
							  use12-hours
							  class="form-control timepicker"
							  placeholder="hh:mm AM/PM"
							/>
							-->
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                </b-col>
                <b-col cols="6">
                  <label>Clocked out</label>
                  <div class="input-group time">
                    <a-date-picker
                      v-model:value="addform.punch_out_time"
                      format="YYYY-MM-DD hh:mm A"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      show-time
                      use12-hours
                      placeholder="Select date and time"
                      class="form-control datetimepicker"
                    />

                    <!--
							<a-time-picker
							  v-model:value="addform.punch_out_time"
							  format="hh:mm A"          
							  value-format="HH:mm"      
							  use12-hours
							  class="form-control timepicker"
							  placeholder="hh:mm AM/PM"
							/> -->
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                </b-col>
              </b-row>

              <b-p class="mb-0 text-muted">
                <div
                  v-if="
                    selectedtimesheet.assigned_shift &&
                    selectedtimesheet.assigned_shift.length > 0
                  "
                >
                  <small
                    class="text-muted"
                    v-for="singleshift in selectedtimesheet.assigned_shift"
                  >
                    Scheduled: {{ singleshift.shift.start_time }} -
                    {{ singleshift.shift.end_time }}
                  </small>
                </div>
                <div v-else>Scheduled: -</div>
              </b-p>
            </b-card>

            <!-- Breaks Section -->
            <b-card>
              <h6 class="mb-3">
                <b-icon icon="cup-hot-fill" class="me-2"></b-icon>
                Breaks
              </h6>

              <!-- Paid Break -->
              <label class="fw-bold">Total paid break time</label>
              <div v-if="addform.dailyreport?.list_breaks?.breaks?.length">
                <b-row
                  class="align-items-center mb-2"
                  v-for="(entry, index) in addform.dailyreport.list_breaks
                    .breaks"
                  :key="index"
                >
                  <b-col cols="5">
                    <div class="input-group time">
                      <a-date-picker
                        v-model:value="entry.punch_out_time_str"
                        format="YYYY-MM-DD hh:mm A"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        show-time
                        use12-hours
                        placeholder="Select date and time"
                        class="form-control datetimepicker"
                      />

                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                  </b-col>
                  <b-col cols="5">
                    <div class="input-group time">
                      <a-date-picker
                        v-model:value="entry.punch_in_time_str"
                        format="YYYY-MM-DD hh:mm A"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        show-time
                        use12-hours
                        placeholder="Select date and time"
                        class="form-control datetimepicker"
                      />

                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                  </b-col>
                  <b-col cols="2">
                    <i
                      class="fa fa-trash"
                      style="cursor: pointer; color: red"
                      @click="removeNewBreak(index)"
                    ></i>
                  </b-col>
                </b-row>
              </div>
              <b-button
                variant="link"
                class="p-0 text-primary"
                @click="addNewBreak"
              >
                <b-icon icon="plus-circle" class="me-1" /> Add a break
              </b-button>

              <br />

              <h6 class="mb-3 mt-3">
                <b-icon icon="cup-hot-fill" class="me-2"></b-icon>
                Unpaid Breaks
              </h6>

              <label class="fw-bold">Total Unpaid break time</label>
              <div
                v-if="
                  addform.dailyreport?.both_list_breaks?.unpaid_breaks?.length
                "
              >
                <b-row
                  class="align-items-center mb-2"
                  v-for="(entry, index) in addform.dailyreport.both_list_breaks
                    .unpaid_breaks"
                  :key="index"
                >
                  <b-col cols="5">
                    <div class="input-group time">
                      <a-date-picker
                        v-model:value="entry.punch_out_time_str"
                        format="YYYY-MM-DD hh:mm A"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        show-time
                        use12-hours
                        placeholder="Select date and time"
                        class="form-control datetimepicker"
                      />

                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                  </b-col>
                  <b-col cols="5">
                    <div class="input-group time">
                      <a-date-picker
                        v-model:value="entry.punch_in_time_str"
                        format="YYYY-MM-DD hh:mm A"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        show-time
                        use12-hours
                        placeholder="Select date and time"
                        class="form-control datetimepicker"
                      />

                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                  </b-col>
                  <b-col cols="2">
                    <i
                      class="fa fa-trash"
                      style="cursor: pointer; color: red"
                      @click="removeNewBreakUnpaid(index)"
                    ></i>
                  </b-col>
                </b-row>
              </div>
              <b-button
                variant="link"
                class="p-0 text-primary"
                @click="addNewBreakUnpaid"
              >
                <b-icon icon="plus-circle" class="me-1" /> Add a break
              </b-button>
            </b-card>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Save</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import moment from "moment";
const currentDate = ref(new Date(moment()));

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import axios from "axios";
import { notification } from "ant-design-vue";

import { Form, Field } from "vee-validate";
import * as Yup from "yup";

var pagination = { total: 0, current: 1, pageSize: 10, showSizeChanger: false };

const columns = [
  {
    title: "Employee Name",
    dataIndex: "team_member",
    key: "team_member",
    sorter: false,
  },
  {
    title: "Worked",
    dataIndex: "worked",
    key: "worked",
    sorter: false,
  },
  {
    title: "Total paid breaks",
    dataIndex: "total_paid_breaks",
    key: "total_paid_breaks",
    sorter: false,
  },
  {
    title: "Total unpaid breaks",
    dataIndex: "total_unpaid_breaks",
    key: "total_unpaid_breaks",
    sorter: false,
  },
  {
    title: "Issues",
    dataIndex: "issues",
    key: "issues",
    sorter: false,
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
    sorter: false,
  },
];

export default {
  name: "DailyReview",
  components: {
    Form,
    Field,
  },
  data() {
    return {
      form: {
        punch_in_time: "",
        punch_out_time: "",
      },
      searchform: { s_employee_id: "", reason: "", designation_id: "" },
      addform: {
        user_id: "",
        designation_id: "",
        punch_in_time: "",
        punch_out_time: "",
      },
      employee_list: [],
      designation_list: [],
      designation_list2: [],
      employee_list2: [],
      Reasons: [
        "No Show",
        "No Longer Required",
        "Personal Emergency",
        "Sick",
        "Unexplained Absence",
        "Other",
      ],
      clockin: "",
      clockout: "",
      timeOptions: this.generateTimeOptions(),
      selectedCheckin: "",
      selectedCheckOut: "",
      selectedDesignation: "",
      defaultAvatar: "avatar-01.jpg",
      selectedtimesheet: [],
      data: [],
      data1: [],
      columns: columns,
      pagination: pagination,
      hoveredItem: null,
      startdate: currentDate,
      addstartdate: currentDate,
      dateFormat: "MMM dd, yyyy",
      dateFormat2: "dd-MM-yyyy",
      userRole: false,
      hasExportPermission: null,
    };
  },
  methods: {
    downloadDailyReview(report, format) {
      const params = new URLSearchParams();
      const selectedDate = moment(this.startdate).format("YYYY-MM-DD");
      if (this.startdate) {
        params.append("selecteddate", selectedDate);
      }
      if (this.searchform.s_employee_id) {
        params.append("s_employee_id", this.searchform.s_employee_id);
      }
      if (this.searchform.reason) {
        params.append("reason", this.searchform.reason);
      }
      if (this.searchform.designation_id) {
        params.append("designation_id", this.searchform.designation_id);
      }

      const token = window.localStorage.getItem("token");
      const url = `${process.env.VUE_APP_API_BASE_URL}${report}?${params.toString()}`;

      const defaultExtension = format === "pdf" ? "pdf" : "xlsx";
      let fileName = `daily-review-${selectedDate}.${defaultExtension}`;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get(url, {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);

          const contentDisposition = response.headers["content-disposition"];
          if (contentDisposition) {
            const matches = contentDisposition.match(/filename="?([^"]+)"?/);
            if (matches && matches[1]) {
              fileName = matches[1];
            }
          }

          link.download = fileName;
          link.click();
          URL.revokeObjectURL(link.href);
          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response?.status == 401 &&
            response?.data?.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch(() => {});
          } else {
            this.errorMessage = error?.message;
            notification.open({
              message: response?.data?.message || "Export failed",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    deleteTimesheet(attendanceid) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      axios.defaults.headers.common["Content-Type"] = "multipart/form-data";

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var postform = new FormData();
      postform.append("employee_attendance_id", attendanceid);

      axios
        .post("/deletedailyreview", postform)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          var startdate = "";
          if (this.startdate != "") {
            startdate = moment(this.startdate).format("YYYY-MM-DD");
            console.log(startdate);
          }

          var params = {
            params: {
              selecteddate: startdate,
              s_employee_id: this.searchform.s_employee_id,
              reason: this.searchform.reason,
              designation_id: this.searchform.designation_id,
              per_page: this.pagination.pageSize,
            },
          };

          this.loadCommonData(params);

          this.$refs.imptimessheetclose.click();
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || null;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    formatTimeRange(startTime, endTime) {
      if (!startTime || !endTime) {
        return "-";
      }

      const start = this.parseTime(startTime);
      const end = this.parseTime(endTime);

      const durationMinutes =
        end.hours * 60 + end.minutes - (start.hours * 60 + start.minutes);
      const hours = Math.floor(durationMinutes / 60);
      const minutes = durationMinutes % 60;

      return `${hours} hr ${minutes} min (${this.to12Hour(
        start
      )} - ${this.to12Hour(end)})`;
    },

    parseTime(timeStr) {
      const [hours, minutes] = timeStr.split(":").map(Number);
      return { hours, minutes };
    },

    to12Hour({ hours, minutes }) {
      const period = hours >= 12 ? "pm" : "am";
      const hour12 = ((hours + 11) % 12) + 1;
      return `${hour12}:${minutes.toString().padStart(2, "0")} ${period}`;
    },
    formatToAmPm(datetimeStr) {
      if (!datetimeStr) return "";

      const date = new Date(datetimeStr);
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    },
    convertHoursToTimeFormat(hours) {
      if (hours == null || isNaN(hours)) return "0 hrs"; // handles null, undefined, NaN

      const hrs = Math.floor(hours);
      const mins = Math.round((hours - hrs) * 60);

      const hrLabel = `${hrs} ${hrs === 1 ? "hr" : "hrs"}`;
      const minLabel = mins > 0 ? ` ${mins} min` : "";

      return hrLabel + minLabel;
    },
    AddEvent2() {
      console.log("hahaha called");
    },
    onSearch() {
      var startdate = "";
      if (this.startdate != "") {
        startdate = moment(this.startdate).format("YYYY-MM-DD");
        console.log(startdate);
      }

      var params = {
        params: {
          selecteddate: startdate,
          s_employee_id: this.searchform.s_employee_id,
          reason: this.searchform.reason,
          designation_id: this.searchform.designation_id,
          per_page: this.pagination.pageSize,
          page: 1,
        },
      };

      this.loadCommonData(params);
    },
    clearForm() {
      this.searchform = { s_employee_id: "", reason: "", designation_id: "" };

      var startdate = "";
      if (this.startdate != "") {
        startdate = moment(this.startdate).format("YYYY-MM-DD");
        console.log(startdate);
      }

      var params = {
        params: {
          selecteddate: startdate,
          s_employee_id: this.searchform.s_employee_id,
          reason: this.searchform.reason,
          designation_id: this.searchform.designation_id,
          per_page: this.pagination.pageSize,
        },
      };
      this.loadCommonData(params);
    },
    loadAllDesignations(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.$refs.formContainer,
      //   canCancel: false,
      // });

      axios
        .get("/designations/all", params)
        .then((response) => {
          //	console.log(response.data.data.data);

          console.log(response.data.data);

          for (let i = 0; i < response.data.data.length; i++) {
            this.designation_list.push({
              id: response.data.data[i].id,
              text: response.data.data[i].name,
            });
          }

          // loader.hide();
        })
        .catch((error) => {
          // loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadAllEmployees(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.$refs.formContainer,
      //   canCancel: false,
      // });

      axios
        .get("/employees/allemployees", params)
        .then((response) => {
          //	console.log(response.data.data.data);

          this.employee_list2 = response.data.data;

          console.log(response.data.data);

          for (let i = 0; i < response.data.data.length; i++) {
            this.employee_list.push({
              id: response.data.data[i].id,
              text:
                response.data.data[i].first_name +
                " " +
                response.data.data[i].last_name,
            });
          }

          // loader.hide();
        })
        .catch((error) => {
          // loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadDesignations(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.$refs.formContainer,
      //   canCancel: false,
      // });

      axios
        .get("/designations/all", params)
        .then((response) => {
          //	console.log(response.data.data.data);

          this.designation_list2 = response.data.data;

          // loader.hide();
        })
        .catch((error) => {
          // loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    generateTimeOptions() {
      const options = [
        { value: "", text: "--:-- --" }, // ← placeholder
      ];

      for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 5) {
          const hour24 = h.toString().padStart(2, "0");
          const minute = m.toString().padStart(2, "0");

          const period = h < 12 ? "AM" : "PM";
          const hour12 = (h % 12 || 12).toString();
          const label = `${hour12}:${minute} ${period}`;

          options.push({ value: `${hour24}:${minute}`, text: label });
        }
      }
      return options;
    },
    onSubmit() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      axios.defaults.headers.common["Content-Type"] = "multipart/form-data";

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var postform = new FormData();

      postform.append("user_id", this.addform.user_id);
      postform.append(
        "timesheet_date",
        moment(this.addstartdate).format("YYYY-MM-DD")
      );

      if (this.addform.punch_in_time != "") {
        /*const datePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
			const timePart = this.addform.punch_in_time; 
			const fullDateTime = moment(`${datePart} ${timePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
			
			postform.append("clocked_in", fullDateTime);*/

        postform.append("clocked_in", this.addform.punch_in_time);
      } else {
        postform.append("clocked_in", "");
      }

      if (this.addform.punch_out_time != "") {
        /*const datePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
			const timePart2 = this.addform.punch_out_time; 
			const fullDateTime2 = moment(`${datePart} ${timePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
			
			postform.append("clocked_out", fullDateTime2);*/

        postform.append("clocked_out", this.addform.punch_out_time);
      } else {
        postform.append("clocked_out", "");
      }

      if (this.addform.dailyreport?.list_breaks?.breaks?.length) {
        this.addform.dailyreport.list_breaks.breaks.forEach((brk, index) => {
          //console.log(brk);

          /*var bdatePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart = brk.punch_out_time_str; 
				var bfullDateTime = moment(`${bdatePart} ${btimePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_out_datetime]`, bfullDateTime);*/

          postform.append(
            `breaks[${index}][clocked_out_datetime]`,
            brk.punch_out_time_str
          );

          /*var bdatePart2 = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart2 = brk.punch_in_time_str; 
				var bfullDateTime2 = moment(`${bdatePart2} ${btimePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_in_datetime]`, bfullDateTime2);*/

          postform.append(
            `breaks[${index}][clocked_in_datetime]`,
            brk.punch_in_time_str
          );
        });
      } else {
        postform.append("breaks", []);
      }

      if (this.addform.dailyreport?.both_list_breaks?.unpaid_breaks?.length) {
        this.addform.dailyreport.both_list_breaks.unpaid_breaks.forEach(
          (brk, index) => {
            //console.log(brk);

            /*var bdatePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart = brk.punch_out_time_str; 
				var bfullDateTime = moment(`${bdatePart} ${btimePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_out_datetime]`, bfullDateTime);*/

            postform.append(
              `unpaid_breaks[${index}][clocked_out_datetime]`,
              brk.punch_out_time_str
            );

            /*var bdatePart2 = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart2 = brk.punch_in_time_str; 
				var bfullDateTime2 = moment(`${bdatePart2} ${btimePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_in_datetime]`, bfullDateTime2);*/

            postform.append(
              `unpaid_breaks[${index}][clocked_in_datetime]`,
              brk.punch_in_time_str
            );
          }
        );
      } else {
        postform.append("unpaid_breaks", []);
      }

      postform.append("designation_id", this.addform.designation_id);

      axios
        .post("/updatedailyreview", postform)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          var startdate = "";
          if (this.startdate != "") {
            startdate = moment(this.startdate).format("YYYY-MM-DD");
            console.log(startdate);
          }

          var params = {
            params: {
              selecteddate: startdate,
              s_employee_id: this.searchform.s_employee_id,
              reason: this.searchform.reason,
              designation_id: this.searchform.designation_id,
              per_page: this.pagination.pageSize,
            },
          };

          this.loadCommonData(params);

          this.$refs.impaddtimessheetclose.click();

          this.addform = { user_id: "", punch_in_time: "", punch_out_time: "" };
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || null;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    onUpdate() {
      console.log("update called");
      console.log(this.selectedtimesheet);

      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      axios.defaults.headers.common["Content-Type"] = "multipart/form-data";

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var postform = new FormData();
      postform.append("user_id", this.selectedtimesheet.id);
      postform.append(
        "timesheet_date",
        moment(this.startdate).format("YYYY-MM-DD")
      );

      if (this.form.punch_in_time != "") {
        /*const datePart = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
			const timePart = this.form.punch_in_time; 
			const fullDateTime = moment(`${datePart} ${timePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
			
			postform.append("clocked_in", fullDateTime);*/

        postform.append("clocked_in", this.form.punch_in_time);
      } else {
        postform.append("clocked_in", "");
      }

      if (this.form.punch_out_time != "") {
        /*const datePart = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
			const timePart2 = this.form.punch_out_time; 
			const fullDateTime2 = moment(`${datePart} ${timePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
			
			postform.append("clocked_out", fullDateTime2);*/

        postform.append("clocked_out", this.form.punch_out_time);
      } else {
        postform.append("clocked_out", "");
      }

      console.log(this.selectedtimesheet.dailyreport?.list_breaks.breaks);

      if (this.selectedtimesheet.dailyreport?.list_breaks?.breaks?.length) {
        this.selectedtimesheet.dailyreport.list_breaks.breaks.forEach(
          (brk, index) => {
            //console.log(brk);

            /*var bdatePart = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart = brk.punch_out_time_str; 
				var bfullDateTime = moment(`${bdatePart} ${btimePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_out_datetime]`, bfullDateTime);*/

            postform.append(
              `breaks[${index}][clocked_out_datetime]`,
              brk.punch_out_time_str
            );

            /*var bdatePart2 = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart2 = brk.punch_in_time_str; 
				var bfullDateTime2 = moment(`${bdatePart2} ${btimePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_in_datetime]`, bfullDateTime2);*/

            postform.append(
              `breaks[${index}][clocked_in_datetime]`,
              brk.punch_in_time_str
            );
          }
        );
      } else {
        postform.append("breaks", []);
      }

      if (
        this.selectedtimesheet.dailyreport?.both_list_breaks?.unpaid_breaks
          ?.length
      ) {
        this.selectedtimesheet.dailyreport.both_list_breaks.unpaid_breaks.forEach(
          (brk, index) => {
            //console.log(brk);

            /*var bdatePart = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart = brk.punch_out_time_str; 
				var bfullDateTime = moment(`${bdatePart} ${btimePart}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_out_datetime]`, bfullDateTime);*/

            postform.append(
              `unpaid_breaks[${index}][clocked_out_datetime]`,
              brk.punch_out_time_str
            );

            /*var bdatePart2 = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
				var btimePart2 = brk.punch_in_time_str; 
				var bfullDateTime2 = moment(`${bdatePart2} ${btimePart2}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
				
				postform.append(`breaks[${index}][clocked_in_datetime]`, bfullDateTime2);*/

            postform.append(
              `unpaid_breaks[${index}][clocked_in_datetime]`,
              brk.punch_in_time_str
            );
          }
        );
      } else {
        postform.append("unpaid_breaks", []);
      }

      axios
        .post("/updatedailyreview", postform)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          var startdate = "";
          if (this.startdate != "") {
            startdate = moment(this.startdate).format("YYYY-MM-DD");
            console.log(startdate);
          }

          var params = {
            params: {
              selecteddate: startdate,
              s_employee_id: this.searchform.s_employee_id,
              reason: this.searchform.reason,
              designation_id: this.searchform.designation_id,
              per_page: this.pagination.pageSize,
            },
          };

          this.loadCommonData(params);

          this.$refs.imptimessheetclose.click();
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || null;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    addNewBreak() {
      this.addform.dailyreport ??= {};
      this.addform.dailyreport.list_breaks ??= { breaks: [] };
      this.addform.dailyreport.list_breaks.breaks ??= [];

      this.addform.dailyreport.list_breaks.breaks.push({
        punch_in_time_str: "",
        punch_out_time_str: "",
      });
    },
    addNewBreakUnpaid() {
      this.addform.dailyreport ??= {};
      this.addform.dailyreport.both_list_breaks ??= { unpaid_breaks: [] };
      this.addform.dailyreport.both_list_breaks.unpaid_breaks ??= [];

      this.addform.dailyreport.both_list_breaks.unpaid_breaks.push({
        punch_in_time_str: "",
        punch_out_time_str: "",
      });
    },
    addBreak() {
      /*this.selectedtimesheet.dailyreport.list_breaks.breaks.push({
		  punch_in_time_str: '',
		  punch_out_time_str: ''
		});*/

      this.selectedtimesheet.dailyreport ??= {};
      this.selectedtimesheet.dailyreport.list_breaks ??= { breaks: [] };
      this.selectedtimesheet.dailyreport.list_breaks.breaks ??= [];

      this.selectedtimesheet.dailyreport.list_breaks.breaks.push({
        punch_in_time_str: "",
        punch_out_time_str: "",
      });
    },
    addBreakUnpaid() {
      this.selectedtimesheet.dailyreport ??= {};
      this.selectedtimesheet.dailyreport.both_list_breaks ??= {
        unpaid_breaks: [],
      };
      this.selectedtimesheet.dailyreport.both_list_breaks.unpaid_breaks ??= [];

      this.selectedtimesheet.dailyreport.both_list_breaks.unpaid_breaks.push({
        punch_in_time_str: "",
        punch_out_time_str: "",
      });
    },
    removeNewBreak(index) {
      this.addform.dailyreport.list_breaks.breaks.splice(index, 1);
    },
    removeNewBreakUnpaid(index) {
      this.addform.dailyreport.both_list_breaks.unpaid_breaks.splice(index, 1);
    },
    removeBreak(index) {
      this.selectedtimesheet.dailyreport.list_breaks.breaks.splice(index, 1);
    },
    removeBreakUnpaid(index) {
      this.selectedtimesheet.dailyreport.both_list_breaks.unpaid_breaks.splice(
        index,
        1
      );
    },
    formatDate(startdate) {
      return moment(startdate).format("ddd, MMM D");
    },
    goToPreviousDay() {
      const date = new Date(this.startdate);
      date.setDate(date.getDate() - 1);
      this.startdate = date;
    },
    goToNextDay() {
      console.log("next called");
      const date = new Date(this.startdate);
      date.setDate(date.getDate() + 1);
      this.startdate = date;
    },
    editTimesheet(record) {
      this.selectedtimesheet = JSON.parse(JSON.stringify(record));

      if (this.selectedtimesheet.dailyreport?.designationdetails) {
        this.selectedDesignation =
          this.selectedtimesheet.dailyreport?.designationdetails.name || "";
      } else {
        this.selectedDesignation =
          this.selectedtimesheet.designation?.name || "";
      }

      if (
        record?.dailyreport?.list_breaks?.breaks &&
        Array.isArray(record.dailyreport.list_breaks.breaks)
      ) {
        this.selectedtimesheet.dailyreport.list_breaks.breaks.forEach((b) => {
          //b.punch_in_time_str = this.extractTime(b.punch_in_employee_attendances_details_time);
          b.punch_in_time_str = b.punch_in_employee_attendances_details_time;
          //b.punch_out_time_str = this.extractTime(b.punch_out_employee_attendances_details_time);
          b.punch_out_time_str = b.punch_out_employee_attendances_details_time;
        });
      }

      if (
        record?.dailyreport?.both_list_breaks?.unpaid_breaks &&
        Array.isArray(record.dailyreport.both_list_breaks.unpaid_breaks)
      ) {
        this.selectedtimesheet.dailyreport.both_list_breaks.unpaid_breaks.forEach(
          (b) => {
            //b.punch_in_time_str = this.extractTime(b.punch_in_employee_attendances_details_time);
            b.punch_in_time_str = b.punch_in_employee_attendances_details_time;
            //b.punch_out_time_str = this.extractTime(b.punch_out_employee_attendances_details_time);
            b.punch_out_time_str =
              b.punch_out_employee_attendances_details_time;
          }
        );
      }

      this.form = { punch_in_time: "", punch_out_time: "" };

      console.log(this.selectedtimesheet);

      if (record.dailyreport && record.dailyreport.firstpunch != "") {
        //this.form.punch_in_time = this.extractTime(record.dailyreport.firstpunch);
        this.form.punch_in_time = record.dailyreport.firstpunch;
      }

      if (record.dailyreport && record.dailyreport.lastpunch != "") {
        //this.form.punch_out_time = this.extractTime(record.dailyreport.lastpunch);
        this.form.punch_out_time = record.dailyreport.lastpunch;
      }
    },
    extractTime(datetime) {
      if (!datetime) return null;
      return new Date(datetime).toTimeString().slice(0, 5); // HH:mm
    },
    extractTime2(timeStr) {
      if (!timeStr) return null;
      return timeStr.slice(0, 5); // returns "23:00"
    },
    onDateChange() {
      console.log("abc........");
      console.log(this.startdate);

      var startdate = "";
      if (this.startdate != "") {
        startdate = moment(this.startdate).format("YYYY-MM-DD");
        console.log(startdate);
      }

      var params = {
        params: {
          selecteddate: startdate,
          s_employee_id: this.searchform.s_employee_id,
          reason: this.searchform.reason,
          designation_id: this.searchform.designation_id,
          per_page: this.pagination.pageSize,
        },
      };

      this.loadCommonData(params);
    },
    handleTableChange(pagesize) {
      var startdate = "";
      if (this.startdate != "") {
        startdate = moment(this.startdate).format("YYYY-MM-DD");
      }

      var params = {
        params: {
          per_page: pagesize.pageSize,
          page: pagesize.current,
          selecteddate: startdate,
          s_employee_id: this.searchform.s_employee_id,
          reason: this.searchform.reason,
          designation_id: this.searchform.designation_id,
        },
      };

      this.loadCommonData(params);
    },
    getInitials(name) {
      return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase();
    },
    getEmployeeAvatar(avatar) {
      return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
    },
    handleImageError(item) {
      item.avatar = null;
      item.avatar = `assets/img/profiles/${this.defaultAvatar}`;
    },
    handleAction(action, item, reason = "") {
      console.log("Selected action:", action, "on", item.name);
      // Add modal or logic based on action

      if (action == "newTimes") {
        this.editTimesheet(item);
        const link = document.createElement("a");
        link.href = "#edit_timesheet"; // or a URL, or modal target
        link.setAttribute("data-bs-toggle", "modal"); // for Bootstrap modal
        link.setAttribute("data-bs-target", "#edit_timesheet"); // modal ID

        document.body.appendChild(link); // must be in DOM
        link.click(); // simulate click
        document.body.removeChild(link); // cleanup
      }

      if (action == "scheduled") {
        console.log(item);

        if (item.assigned_shift.length == 0) {
          notification.open({
            message: "No Schedule Found!!",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_WARNING_COLOR,
            },
          });

          return;
        } else if (item.assigned_shift.length > 1) {
          notification.open({
            message: "Multiple Schedule Found!!",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_WARNING_COLOR,
            },
          });

          return;
        }

        this.selectedtimesheet = JSON.parse(JSON.stringify(item));

        if (this.selectedtimesheet.dailyreport?.designationdetails) {
          this.selectedDesignation =
            this.selectedtimesheet.dailyreport?.designationdetails.name || "";
        } else {
          this.selectedDesignation =
            this.selectedtimesheet.designation?.name || "";
        }

        //this.selectedDesignation = this.selectedtimesheet.designation?.name || '';

        if (
          item?.dailyreport?.list_breaks?.breaks &&
          Array.isArray(item.dailyreport.list_breaks.breaks)
        ) {
          this.selectedtimesheet.dailyreport.list_breaks.breaks.forEach((b) => {
            //b.punch_in_time_str = this.extractTime(b.punch_in_employee_attendances_details_time);

            b.punch_in_time_str = b.punch_in_employee_attendances_details_time;

            //b.punch_out_time_str = this.extractTime(b.punch_out_employee_attendances_details_time);

            b.punch_out_time_str =
              b.punch_out_employee_attendances_details_time;
          });
        }

        if (
          item?.dailyreport?.both_list_breaks?.unpaid_breaks &&
          Array.isArray(item.dailyreport.both_list_breaks.unpaid_breaks)
        ) {
          this.selectedtimesheet.dailyreport.both_list_breaks.unpaid_breaks.forEach(
            (b) => {
              //b.punch_in_time_str = this.extractTime(b.punch_in_employee_attendances_details_time);

              b.punch_in_time_str =
                b.punch_in_employee_attendances_details_time;

              //b.punch_out_time_str = this.extractTime(b.punch_out_employee_attendances_details_time);

              b.punch_out_time_str =
                b.punch_out_employee_attendances_details_time;
            }
          );
        }

        this.form = { punch_in_time: "", punch_out_time: "" };

        console.log(this.selectedtimesheet);

        if (
          item.assigned_shift.length > 0 &&
          item.assigned_shift[0].shift &&
          item.assigned_shift[0].shift.start_time
        ) {
          //this.form.punch_in_time = this.extractTime2(item.assigned_shift[0].shift.start_time);

          var bdatePart = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
          var btimePart = item.assigned_shift[0].shift.start_time;
          var bfullDateTime = moment(
            `${bdatePart} ${btimePart}`,
            "YYYY-MM-DD HH:mm"
          ).format("YYYY-MM-DD HH:mm:ss");

          this.form.punch_in_time = bfullDateTime;
        }

        if (
          item.assigned_shift.length > 0 &&
          item.assigned_shift[0].shift &&
          item.assigned_shift[0].shift.end_time
        ) {
          //this.form.punch_out_time = this.extractTime2(item.assigned_shift[0].shift.end_time);
          //this.form.punch_out_time = item.assigned_shift[0].shift.end_time;

          var bdatePart = moment(this.startdate).format("YYYY-MM-DD"); // → "2025-06-25"
          var btimePart = item.assigned_shift[0].shift.end_time;
          var bfullDateTime = moment(
            `${bdatePart} ${btimePart}`,
            "YYYY-MM-DD HH:mm"
          ).format("YYYY-MM-DD HH:mm:ss");

          this.form.punch_out_time = bfullDateTime;
        }

        /*if(record.dailyreport && record.dailyreport.firstpunchval != ""){
				this.form.punch_in_time = this.extractTime(record.dailyreport.firstpunchval);
			}
			
			if(record.dailyreport && record.dailyreport.lastpunchval != ""){
				this.form.punch_out_time = this.extractTime(record.dailyreport.lastpunchval);
			}*/

        const link = document.createElement("a");
        link.href = "#edit_timesheet"; // or a URL, or modal target
        link.setAttribute("data-bs-toggle", "modal"); // for Bootstrap modal
        link.setAttribute("data-bs-target", "#edit_timesheet"); // modal ID

        document.body.appendChild(link); // must be in DOM
        link.click(); // simulate click
        document.body.removeChild(link); // cleanup
      }

      if (action == "reason") {
        console.log(action);
        console.log(item);
        console.log(reason);

        var token = window.localStorage.getItem("token");

        axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        axios.defaults.headers.common["Content-Type"] = "multipart/form-data";

        let loader = this.$loading.show({
          // Optional parameters
          container: this.$refs.formContainer,
          canCancel: false,
        });

        var postform = new FormData();

        postform.append("reason", reason);
        postform.append(
          "timesheet_date",
          moment(this.startdate).format("YYYY-MM-DD")
        );
        postform.append("user_id", item.id);

        axios
          .post("/adddailyreviewreason", postform)
          .then((response) => {
            loader.hide();

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_SUCCESS_COLOR,
              },
            });

            var startdate = "";
            if (this.startdate != "") {
              startdate = moment(this.startdate).format("YYYY-MM-DD");
              console.log(startdate);
            }

            var params = {
              params: {
                selecteddate: startdate,
                s_employee_id: this.searchform.s_employee_id,
                reason: this.searchform.reason,
                designation_id: this.searchform.designation_id,
                per_page: this.pagination.pageSize,
              },
            };

            this.loadCommonData(params);
          })
          .catch((error) => {
            loader.hide();

            if (error.response) {
              var response = error.response;

              this.errors = response?.data?.error || null;

              notification.open({
                message: response.data.message,
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            } else {
              notification.open({
                message: "Server Error",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            }
          });
      }
    },
    toggleSubmenu(id) {
      this.showReasonSubmenuId = this.showReasonSubmenuId === id ? null : id;
    },
    updatePerPage() {
      var startdate = "";
      if (this.startdate != "") {
        startdate = moment(this.startdate).format("YYYY-MM-DD");
      }

      var params = {
        params: {
          per_page: this.pagination.pageSize,
          selecteddate: startdate,
          s_employee_id: this.searchform.s_employee_id,
          reason: this.searchform.reason,
          designation_id: this.searchform.designation_id,
        },
      };
      this.loadCommonData(params);
    },
    loadCommonData(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/dailyreview", params)
        .then((response) => {
          this.data = response.data.data;

          console.log(response.data.data);

          // this.data = response.data.data.data;

          if (response.data.meta) {
            this.pagination.total = response.data.meta.total;
            this.pagination.current = response.data.meta.current_page;
            this.pagination.pageSize = response.data.meta.per_page;
            console.log(this.pagination.pageSize);
          }

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response?.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
  },
  mounted() {
    var startdate = "";
    if (this.startdate != "") {
      startdate = moment(this.startdate).format("YYYY-MM-DD");
      console.log(startdate);
    }

    var roleget = window.localStorage.getItem("role");
    if (roleget && roleget.includes("Employee")) {
      this.userRole = true;
    }

    this.$store
      .dispatch("userPermissions", { module: "timing_sheet", action: "export" })
      .then((response) => {
        this.hasExportPermission = null;
        this.$nextTick(() => {
          this.hasExportPermission = response === "true";
        });
      });

    var params = {
      params: {
        selecteddate: startdate,
        s_employee_id: this.searchform.s_employee_id,
        reason: this.searchform.reason,
        designation_id: this.searchform.designation_id,
        per_page: this.pagination.pageSize,
      },
    };
    this.loadCommonData(params);
    this.loadDesignations([]);
    this.loadAllEmployees([]);
    this.loadAllDesignations([]);
  },
  setup() {
    const schema = Yup.object().shape({
      user_id: Yup.string().required("Employee is required"),
    });

    return {
      schema,
    };
  },
  watch: {
    startdate(newVal) {
      if (newVal) {
        this.onDateChange();
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-right: 10px;
}
.dropdown-menu {
  min-width: 180px;
}
.submenu-trigger {
  position: relative;
}

.submenu-dropdown {
  position: absolute;
  top: 0;
  right: 100%; /* show on the left */
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 0.25rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1050;
  min-width: 220px;
  padding: 0.25rem 0;
}

:deep(.ant-avatar .ant-avatar-string) {
  position: static;
}
</style>
